export class YearlySalesCountRequest {
  //#region : Constructor :
  constructor(userName?: string, saleDate?: Date, agentCode?: string, dealerCode?: string, useSefi?: boolean) {
    this.userName = userName;
    this.saleDate = saleDate;
    this.agentCode = agentCode;
    this.dealerCode = dealerCode;
    this.useSefi = useSefi;
  }
  //#endregion

  //#region : Properties :
  public userName: string;
  public saleDate: Date;
  public agentCode: string;
  public dealerCode: string;
  public useSefi: boolean;
  //#endregion
}
